import { Injectable } from "@angular/core";
import { SessionService, User, UserRole } from "@edl-development/edl-common";
import { PaetepRoles } from "src/app/model/enum/rubric/user-role-names.enum";

@Injectable()
export class UserRoleHelperService {

    constructor(private sessionService: SessionService) { }

    isNTPESupervisor = (user:User) => {

      let ntpeSupervisorRoles = [
        PaetepRoles.SupervisorCurriculumInstruction,
        PaetepRoles.SupervisorPupilServices,
        PaetepRoles.SupervisorSpecialEducation,
        PaetepRoles.SupervisorVocationalEducation,
        PaetepRoles.SupervisorNTPEOther
      ];
      let userRoles = user.UserRoles;
      let roleFound = userRoles.find((i:any) => ntpeSupervisorRoles.includes(i.RoleName));
      return roleFound != null;
    }

    IsDistrictAdmin = (user:User) => {

      let userRoles = user.UserRoles;
      let roleFound = userRoles.find((i:any) => i.RoleName == PaetepRoles.DistrictAdmin);
      return roleFound != null;
    }

    IsAdmin = (user:User) => {

      let userRoles = user.UserRoles;
      let roleFound = userRoles.find((i:any) => i.RoleName == PaetepRoles.DistrictAdmin);
      return roleFound != null || user.IsSuperUser;
    }

}
